module.exports = __webpack_public_path__ + "img/hz2.37eb12e3.png";